import { createSlice } from '@reduxjs/toolkit';

const transactionsSlice = createSlice({
  name: 'transactions',
  initialState: {
    transactions: [],
  },
  reducers: {
    addTransaction: (state, action) => {
      state.transactions.push(action.payload);
    },
    setTransactions: (state, action) => {
      state.transactions = action.payload;
    },
    clearTransactions: (state) => {
      state.transactions = [];
    },
  },
});

export const { addTransaction, setTransactions, clearTransactions } = transactionsSlice.actions;
export const selectAllTransactions = (state) => state.transactions.transactions;
export default transactionsSlice.reducer;
